module.exports = __webpack_public_path__ + "static/media/main-user-info-back.ce78a6d3.png";